<template>
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Overlay di caricamento ( usato quando si cambia password ) -->
    <CustomOverlay :show="overlay_show" text="Richiesta in corso, attendere...">

      <!-- Card principale della pagina con le info utente -->
      <b-card no-body>
        <b-card-header>
          <h5><b-icon icon="person" font-scale="2"></b-icon> Il Mio Profilo</h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col>
              <b-table-simple responsive borderless fixed stacked="sm">
                <b-tbody>
                  <b-tr>
                    <b-td class="voices-align"><b>Nome:</b></b-td>
                    <b-td><em>{{user_data.nome}}</em></b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="voices-align"><b>Cognome:</b></b-td>
                    <b-td><em>{{user_data.cognome}}</em></b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="voices-align"><b>Email:</b></b-td>
                    <b-td><em>{{user_data.email}}</em></b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="voices-align"><b>Codice Fiscale:</b></b-td>
                    <b-td><em>{{user_data.cod_fisc}}</em></b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="voices-align"><b>Azienda:</b></b-td>
                    <b-td><em>{{user_data.azienda}}</em></b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <b-button variant="primary" @click="open_change_passwd_modal">Cambia password</b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </CustomOverlay>

    <!-- Modale con il form di cambio password -->
    <b-modal ref="change_passwd_modal"
        title="Cambio password"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer>
      <!-- Form per la password con relativa conferma il footer non lo visualizzo -->
      <!-- di modo tale da poterlo sostituire con i due pulsanti di controllo     -->
      <!-- ( cancel e submit ) del form.                                          -->
      <b-form @submit.prevent="passwd_change">
        <h6>Ricorda che la nuova password:</h6>
        <ul>
          <li>deve avere una lunghezza compresa tra un minimo di 8 e un massimo di 32 caratteri.</li>
          <li>deve contenere almeno un carattere maiuscolo, uno minuscolo e un numero.</li>
          <li>non deve essere già stata utilizzata in passato.</li>
        </ul>
        <!-- Nuova password e conferma password -->
        <FormNuovaPassword @dataChanged="new_passwd_form_change"/>
        <div class="text-right">
          <b-button class="mr-1" @click="close_passwd_modal_and_clean">Annulla</b-button>
          <b-button class="ml-1" type="submit" variant="primary" :disabled="change_passw_btn_disabled">Procedi</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import FormNuovaPassword from '@/components/FormNuovaPassword'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'


export default {
  name: 'UserProfile',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Il mio profilo", link : 'user-profile' } ],
      overlay_show : false,

      // Dati per il cambio password
      form : {
        new_passwd: null,
        passwd_confirm: null
      },

      // Dati per lo stato del contenuto del form
      form_state : {
        new_passwd_state: null,
        passwd_confirm_state: null
      },

      // Dati utente da visualizzare nella pagina
      user_data : {
        nome: this.$store.state.user.user_anag.nome,
        cognome: this.$store.state.user.user_anag.cognome,
        email: this.$store.state.user.user_anag.email,
        cod_fisc: this.$store.state.user.user_anag.cod_fisc,
        azienda: this.$store.state.user.user_azi.nome + ' ' + this.$store.state.user.user_azi.cognome
      }
    }
  },
  computed: {
    /**
     * Abilita/disabilita il botton di cambio password a seconda dello stato
     * del form di modifica password.
     */
    change_passw_btn_disabled : function() {
      if ( this.form_state.new_passwd_state === false || this.form_state.passwd_confirm_state === false ){
        return true;
      } else {
        return false;
      }
    }
  },
  methods : {
    /**
     * Apre la modale per il cambio della password.
     */
    open_change_passwd_modal : function () {
      this.$refs['change_passwd_modal'].show()
    },
    /**
     * Chiude la modale per il cambio password pulendo anche
     * le informazioni del form.
     */
    close_passwd_modal_and_clean : function () {
      this.$refs['change_passwd_modal'].hide()
      this.form.new_passwd = null;
      this.form.passwd_confirm = null;
      this.form_state.new_passwd_form_change = null;
      this.form_state.passwd_confirm_state = null;
    },
    /**
     * Aggiorna le variabili interne di questo componente con quanto
     * dato dal form di modifica password.
     */
    new_passwd_form_change : function (data) {
      this.form.new_passwd = data.new_passwd;
      this.form.passwd_confirm = data.passwd_confirm;
      this.form_state.new_passwd_form_change = data.new_passwd_state;
      this.form_state.passwd_confirm_state = data.passwd_confirm_state;
    },
    /**
     * Chiama la funzione di backend per eseguire il cambio password
     */
    passwd_change : function () {

      this.overlay_show = true;

      axios.post( apiUrl.userapi.password_change, this.form )
      .then( ( response ) => {
        // Se ok dobbiamo: chiudere la modale, togliere l'overlay, mostrare il messaggio di successo
        this.close_passwd_modal_and_clean();
        this.overlay_show = false;

        let scad_message = '';
        // Se la password non ha data di scadenza questa porzione del messaggio non la visualizziamo
        if ( response.data.pass_expiry_date != null ) {
          scad_message = " La nuova password scadrà il " + response.data.pass_expiry_date + ".";
        }
        let message = "Password modificata con successo. " + scad_message;

        this.$bvModal.msgBoxOk( message, {
          title: 'Cambio Password',
          centered: true
        });

      })
      .catch( ( error ) => {
        this.overlay_show = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    }
  },
  components : {
    PageTagline,
    CustomOverlay,
    FormNuovaPassword
  }
}
</script>


<style scope>
/* Quando la tabella è in modalità stacked su schermi molto piccoli,
   va ad allineare i titoli delle voci verso sinistra, altrimenti sono
   allineati verso destra centrando le info in mezzo allo schermo */
.voices-align {
  text-align: left!important;
}
@media (min-width: 576px) {
  .voices-align {
    text-align: right!important;
  }
}
</style>